<template>
  <div>
    <b-button
      variant="danger"
      size="sm"
      class="d-inline-flex align-items-center"
      @click="$refs.confirmDelete.$refs.modal.show()"
    >
      <b-icon-trash aria-hidden="true" class="mr-1" />
      Delete
    </b-button>
    <DeleteDashboardConfirm ref="confirmDelete" :url="deleteUrl" :name="name" />
  </div>
</template>

<script>
import DeleteDashboardConfirm from '@/xvisor/components/custom/DeleteDashboardConfirm.vue';

export default {
  components: {
    DeleteDashboardConfirm,
  },
  props: {
    deleteUrl: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
  },
};
</script>
